import { apiGet } from 'api';
import { GetResponseTypesResponse } from '../../types';

export const getResponseTypes = (): Promise<GetResponseTypesResponse> =>
  apiGet<GetResponseTypesResponse>('responsetypes');
